import script from "./TaskInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskInfo.vue?vue&type=script&setup=true&lang=js"

import "./TaskInfo.vue?vue&type=style&index=0&id=14c1e621&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c1e621"]])

export default __exports__